import CreatorSuggestionPage from './creator-suggestion.page';

export default CreatorSuggestionPage;
